import { render, staticRenderFns } from "./NpBoolean.vue?vue&type=template&id=0af45283"
import script from "./NpBoolean.vue?vue&type=script&lang=js"
export * from "./NpBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports